const savedCartsJson = localStorage.getItem('selfservice_carts');
let initialCarts = null;
if (savedCartsJson) {
  try {
    initialCarts = JSON.parse(savedCartsJson);
  } catch (e) {
    initialCarts = null;
  }
}

if (!initialCarts || !initialCarts.length) {
  initialCarts = [{
    id: 0,
    cartEntries: [],
    totalPrice: 0,
    totalPayedPrice: 0,
    active: true,
    isNavigatedByQuestion: false
  }];
}

const initialSession = {
  isActive: false,
  cloneCurrentCart: null,
  paymentGroups: [],
  orderPayments: [],
  discounts: [],
  isPaymentStarted: false,
  isPieced: false
};

export default {

  clientSessionId: null,
  productList: [],
  preSelectedProduct: null,
  selectedProduct: null,
  cartEntry: {},
  carts: initialCarts,
  paymentSessionState: initialSession,
  screenLock : true,
  pinEntryOpen: false,
  isLoading:false,
  activePersonal : null,
  personList:[],
  toUpdateEntry : null,
  isReset : false,
  /** Başarılı ödeme / zayiat geçişi: ProductListPage breadcrumb sıfırlaması (isReset yarışından bağımsız). */
  productNavResetEpoch: 0,
  lastBillId : 0,
  paymentMethods : [],
  selectedPaymentMethod : null,
  isLossModeOn : false,
  lossTypeSelection: true,
  selectedLossStocks:[],
  isCakeQuestioned : false,
  navigationQuestion: {},
  hasNeedNavigationByQuestion: false,
  notifications: [],
  discountReasons: []
};
